/**
 * Adds autocomplete logic to the template defined in src/html/templates/partials/autocomplete.html
 */
function AutoComplete(opts) {

    let autoCompleteJS, lastQuery = null;
    let lastResults = [];
    let input = opts.element.querySelector('input');
    let url = new UrlHelper();
    let events = [];

    let containerHeight = opts.element.getBoundingClientRect().height;

    if (url.get('q')) {
        input.value = url.get('q');
    }

    // -- create autocomplete field
    autoCompleteJS = new autoComplete({
        threshold: 0,
        maxResults: 10,
        debounce: 300,
        selector: () => {
            return input
        },
        searchEngine: function (query, record) {
            if (record.toLowerCase().includes(query)) {
                let regex = new RegExp(query, 'ig');
                return record.replace(regex, `<span class="highlight">${query}</span>`);
            }

            return record;
        },
        data: {
            keys: opts.data.keys,
            src: async (query) => {

                // -- do not load anything on empty query
                if (!query.trim().length) {
                    return [];
                }

                // -- return cached result if the query is the same
                if (query && lastQuery && query.trim() === lastQuery.trim() && lastResults) {
                    this.callEvent('onKeywordsReady', lastResults);
                    return lastResults;
                }

                // -- fetch data using given data provider
                const data = await opts.data.src(query);

                lastQuery = query;
                lastResults = opts.transform(data);

                this.callEvent('onKeywordsReady', lastResults);
                return lastResults;
            },
        },
        resultsList: {
            class: 'results',
            noResults: false,
            maxResults: 10,
            position: 'afterbegin',
            destination: '.search-box',
            element: function (elem, query) {

                setTimeout(() => {
                    let dims = elem.getBoundingClientRect();
                    opts.element.style.height = `${dims.height + containerHeight + 10}px`
                }, 1)

                return elem;
            },
        },
        resultItem: {
            highlight: true,
            selected: 'selected',
            element: function (list, data) {

                let content = list.innerHTML;
                list.innerHTML = `<div class="search-result">${content}</div>`;
                return list;
            }
        },

        events: {

            input: {

                // -- selected term
                selection: function (event) {
                    this.value = event.detail.selection.value[opts.data.keys];
                    opts.events.onKeywordSelected(this.value.trim());
                    autoCompleteJS.close();
                },

                keyup: function (event) {
                    if (!this.value.trim()) {
                        opts.element.removeAttribute('style');
                        opts.element.classList.remove('opened')
                    }

                    // -- execute
                    if (event.keyCode === 13) {
                        if (this.value.trim()) {
                            opts.events.onKeywordSelected(this.value.trim());
                            autoCompleteJS.close();
                        }
                    }
                },
                navigate: function (event) {
                    this.value = event.detail.selection.value[opts.data.keys];
                },

                // -- reopen results list on input focus
                focus() {

                    const inputValue = autoCompleteJS.input.value;
                    if (inputValue.length || lastQuery) autoCompleteJS.start();
                },
                close: function () {
                    setTimeout(() => {
                        opts.element.removeAttribute('style');
                        opts.element.classList.remove('opened')
                    }, 1)
                },
                open: function () {
                    opts.element.classList.add('opened')
                }
            },
        },
    });


    this.getKeyword = function () {
        return autoCompleteJS.input.value.trim();
    }

    this.getSuggestions = function () {
        return lastResults;
    }

    this.attachEvent = function (name, callback) {
        events.push({
            name,
            callback
        });
    }

    this.callEvent = function (name, ...args) {
        events.forEach((e) => {
            if (e.name === name && typeof e.callback === 'function') {
                e.callback.apply(this, args);
            }
        })
    }
}